import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import classNames from 'classnames';

let dialogStyles = {
  padding: '0px',
  top: 'inherit',
  left: 'inherit',
  minHeight: 'inherit',
  zIndex: 1000,
  position: 'relative',
  width: 'auto',
  display: 'block',
  borderRadius: '8px',
  boxShadow: "0 8px 16px 0 rgba(0,25,65,0.16)"
};
let overlayStyles = {
  zIndex: 1070,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
};
let closeButtonStyle = {
  display: 'none',
};
let emptyStateSpinnerStyle = {
  top: '0px',
};

class DefaultSkyLightStateless extends React.Component {

  componentDidUpdate() {
    if(this.props.isVisible) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }

  render() {
    let { isVisible } = this.props;
    let skylightWrapperClass = classNames({
      "hidden": !isVisible
    });

    return (
      <div className={skylightWrapperClass}>
        <SkyLightStateless
          {...this.props}
          isVisible={isVisible}
          dialogStyles={dialogStyles}
          overlayStyles={overlayStyles}
          closeButtonStyle={closeButtonStyle}
          className="skylight-modal-wrapper"
        >
          {isVisible ? (
            this.props.children
            ) : (
              null
            )
          }
        </SkyLightStateless>
      </div>
    )
  }

}

export default DefaultSkyLightStateless;
